module.exports = __webpack_public_path__ + "c48354203ff0e098ddc84d8d2d8bcada.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/plaisirs-gastronomiques/02.jpg
// module id = uvPU
// module chunks = 0